import { Component, effect, Input, SimpleChanges } from '@angular/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { UnitTypeEnum } from '../../../models/unit-type-enum';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';
import { DecimalPipe } from '@angular/common';
import { ReportsChartEnum } from 'src/app/reports/models/enums/reports.enum';

@Component({
  selector: 'app-overview-card',
  templateUrl: './overview-card.component.html',
  styleUrls: ['./overview-card.component.scss']
})
export class OverviewCardComponent {

  @Input() card_title: any;
  @Input() total_current: any;
  @Input() untillDate: any;
  @Input() total_prev: any;
  @Input() total_percentage: any;
  @Input() uniType:any=null;
  @Input() graphData:any;
  @Input() neighborhood:string='';
  @Input() formatInternation:boolean=false;
  @Input() isWas: boolean = true;
  @Input() infoTooltip: boolean = false;
  @Input() infoTooltipContent: string = '';
  @Input() BasedOnRentalsText: boolean = false;
  @Input() propertiesCount: any = '';
  @Input() rentalsName: any = '';
  @Input() card_sub_title: any = '';
  @Input() showTooltip : boolean = false;
  @Input() toolTipContent: string = "";
  @Input() areaName : string= "";
  @Input() expectedDate: string = "";
  @Input() developerText : any = "";
  @Input() underConstructionText: any = "";
  @Input() showDeveloped: boolean=false;
  @Input() bhr_price_sqft:any='';
  @Input() minDate : String = '';
  @Input() maxDate : String = '';
  @Input() gradeWise: boolean = false;
  isShowtransactionDate : boolean = true;
  current:any;
  symble:string='';
  totalSumValue: any;
  lang: string = 'en';

  averageRentRate = new Map();
  occupancyRate = new Map();
  chartView = ReportsChartEnum;
  bhr_symble_sqft: string='';
  UnitTypeEnum: any = UnitTypeEnum;
  constructor(
    private sharedService: SharedService,
    private translate: TranslateService,
    public reportService: ReportService,
    private decimalPipe: DecimalPipe
  ){
    effect(() => {
      this.isShowtransactionDate = this.reportService.ttmToggleVariable();
    })
  }
  ngOnInit(){
    this.sharedService.language$.subscribe(lang => {
      this.lang = lang;
      this.symbleType();
    })

  }

  ngOnChanges(changes: SimpleChanges) {
     //gradeWiseData
    if (this.gradeWise) {
      const labelMap: any = {
        grade_a_p: 'a_p',
        grade_a: 'a',
        grade_b: 'b',
        grade_c: 'c'
      }
      this.graphData?.data?.forEach((item: any) => {
        if (labelMap[item.grade]) {
          item.grade = labelMap[item.grade];
        } else {
          item.grade = '-';
        }
      })
    }
    
    this.bhr_price_sqft = this.decimalPipe.transform((this.bhr_price_sqft), '1.0-1');

    if(this.total_current && this.formatInternation && changes['total_current']) {
      this.current = this.reportService.formatInternationNum(this.total_current);
    }else{
      this.current = this.decimalPipe.transform((this.total_current), '1.0-1');
    }

    if(this.developerText){
      this.developerText = this.decimalPipe.transform((this.developerText), '1.0-1');
    }
    if(this.underConstructionText){
      this.underConstructionText = this.decimalPipe.transform((this.underConstructionText), '1.0-1');
    }
    if(this.propertiesCount) this.propertiesCount = this.decimalPipe?.transform((this.propertiesCount), '1.0-1');
    this.symbleType();
   
  }

  symbleType(){
    this.bhr_symble_sqft = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squarefeetUnit)}`;
    if(this.uniType == UnitTypeEnum.sqm){
      this.symble = this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)
    }
    if(this.uniType == UnitTypeEnum.percentage){
      this.symble = GlobalContants.keySymbolContants.percentage
    }
    if(this.uniType == UnitTypeEnum.currency){
      this.symble = this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode));
    }
    if(this.uniType == UnitTypeEnum.currencywithsqm){
      this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)}`;
    }
    if(this.uniType == UnitTypeEnum.currencywithsqrt){
      this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squarefeetUnit)}`;
    }
  }

  getOpacity(index:number, value: any): string{
    // Adjust the factor and starting value as per your requirement
    return this.changeOpacity(index, value);
  }

  getNumber(nbr: any){
    return +nbr;
  }
  changeOpacity(index: number, value: any){

    if(this.graphData?.type === 'averageRentRate'){

      if(this.averageRentRate.has(value)){
        return this.averageRentRate.get(value);
      } else {
        this.averageRentRate.set(value, this.getOpacityVal(index));
        return this.getOpacityVal(index);
      }

    } else {
      if(this.occupancyRate.has(value)){
        return this.occupancyRate.get(value);
      } else {
        this.occupancyRate.set(value, this.getOpacityVal(index));
        return this.getOpacityVal(index);
      }
    }

  }

  getFormattedDate(dateString: any) {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear().toString().slice(-2); // '24'
    const month = date.toLocaleString('default', { month: 'long' }); // 'May'

    // Get ordinal suffix
    const suffix = (n: number) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    return `${day}${suffix(day)} ${month} ${year}'`; // e.g., 15th May 24’
  }

  getOpacityVal(index:number): string{
    // Adjust the factor and starting value as per your requirement
    return (1 - (index * 0.1)).toFixed(2);
  }
  ngOnDestroy() {
    this.minDate = "";
    this.maxDate = "";
  }
}
